import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DonationComponent from "../../components/donation";
import { fetchRelationshipDataByRID, fetchRelationshipByDomainName, getAuthNetPaymentUrl, processCardPayment, emailReceipt } from './action';
import { showModal, hideModal, pushModalToStack, popModalFromStack, fetchDonationSetting } from '../../actions/commonActions';
import queryString from 'query-string';
import * as find from 'lodash.find';
import * as filter from 'lodash.filter';
import { CONSTANTS } from '../../static/constants';
import config from '../../config/environmentConfig';
import CryptoJS from "crypto-js";

class Register extends Component {
    constructor(props) {
        super(props);
      const queryProps = queryString.parse(this.props.location.search) || {};
      const linkProps = queryString.parse(window.location.search) || {};
      const bytes = linkProps.token ? CryptoJS.AES.decrypt(linkProps.token, config.ENCRYPT_SECRET) : null;
      const token = bytes ? JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) : {};

        this.state = {
            formSetting: {},
            status: queryProps.status,
            //relationshipId: linkProps.relationshipId,
           // source: linkProps.source,
            donationSettings: {},
            amount: 0,
            neverExpires: 1,
            duration: 'oneTime',
            paymentStartDate: new Date(),
            amountCursor: 0, 
            relationshipId: token.relationshipId,
            source: token.source,
            token:linkProps.token 
        }
    }
    componentDidMount() {
        const linkProps = queryString.parse(this.props.location.search) || {};
        const bytes = linkProps.token ? CryptoJS.AES.decrypt(linkProps.token, config.ENCRYPT_SECRET) : null;
        const load = bytes ? JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) : {};
        this.props.fetchDonationSetting(load);
        this.props.fetchRelationshipDataByRID(load);
        //this.props.fetchRelationshipByDomainName({ domainName: window.location.host, source: linkProps.source || ''}, this.props);
    }

    componentWillReceiveProps(props) {
        if (props.donationSettings && props.donationSettings.settingsDonationId) {
            let donationContent = JSON.parse(props.donationSettings.donationContent);
            this.setState({
                relationshipId: props.donationSettings.relationshipId,
                settingsDonationId: props.donationSettings.settingsDonationId,
                donationSettings: donationContent,
                formHeading: donationContent.formHeading,
                isTransactionFeeApplyByDefault: donationContent.isTransactionFeeApplyByDefault? 1: 0
            })
        }
        if (props.companyInfo && props.companyInfo.relationshipId) {
            const allRelationshipBillingAddress = filter((props.companyInfo || {}).boLocationList || [], { locationType: CONSTANTS.RELATIONSHIP_BILLING_ADDRESS }) || [];
            const relationshipBillingAddress = find(allRelationshipBillingAddress, { isDefault: 1 });
            this.setState({
                relationshipBillingAddress,
            })
        }
    }
    render() {
        window.document.title= this.props?.companyInfo?.storeName || '';
        return <div>
             {Object.keys(this.props.donationSettings).length ? <DonationComponent {...this.props} {...this.state} updateState={(data) => { this.setState(data) }} /> : <div></div>} 
        </div>
    }
}
const mapStateToProps = (state) => {
    return {
        common: state.common,
        companyInfo: state.common.relationshipData,
        relationshipId: state.common.relationshipData?.relationshipId,
        donationSettings: state.donation.donationSettings,
    }
}
const mapDispatchToProps = (dispatch) => bindActionCreators({
    showModal, 
    hideModal, 
    pushModalToStack, 
    popModalFromStack,
    fetchRelationshipDataByRID,
    fetchRelationshipByDomainName,
    fetchDonationSetting,
    getAuthNetPaymentUrl,
    processCardPayment,
    emailReceipt
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Register);
